import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineLoading } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import ListTable, { IField } from "../../components/ListTable";
import { IToggleMenuOption } from "../../components/ToggleMenuButton";
import { useAuth } from "../../contexts/auth";
import { useFormModal } from "../../contexts/formModal";
import {
  getBalance,
  getClosedOrders,
  getCoin,
  getCoinClosed,
  getCoinPending,
  getFields,
  getOpenOrders,
  getPendingOrders,
  postPauseOrder,
  postSellOrder,
} from "../../services/orders";
import { getWhiteListOnlyNames } from "../../services/whiteList";
import { orderCols } from "../../utils/form";
import LabelModal from "./labelModal";
import {
  Button,
  Column,
  Container,
  DivCard,
  Row,
  RowModal,
  Title,
  Form,
  Content,
  Footer,
  SelectedContainer,
  PaginateContainer,
  RowButtonOrder,
} from "./style";
import useFetch from "../../hooks/useFetch";
import Toast from "../../components/Toast";
import { IoIosArrowDown } from "react-icons/io";
import { isAfter } from "date-fns";
import { parseISO } from "date-fns/esm";

interface IOrder {
  title?: string;
  endpoint: string;
  filters: object;
  multipleSelect: boolean;
}

export interface IResponse {
  docs: any[];
  totalPages: number;
  total: number;
}

const Order: React.FC<IOrder> = ({
  title,
  endpoint,
  filters,
  multipleSelect,
}) => {
  const { user } = useAuth();
  const { openModal, closeModal } = useFormModal();
  const [balance, setBalance] = useState([]);
  const provider = useFetch({ endpoint: `${endpoint}/tipos-de-entrada` });
  const fields = useFetch({ endpoint: `${endpoint}/campos` });
  const [orders, setOrders] = useState<IResponse | null>(null);
  const [filteredOrders, setFilteredOrders] = useState<IResponse | null>(null);
  const [ordersClosed, setOrdersClosed] = useState<IResponse | null>(null);
  const [ordersPending, setOrdersPending] = useState<IResponse | null>(null);
  const [filteredOrdersClosed, setFilteredOrdersClosed] =
    useState<IResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [loadingSellOrder, setLoadingSellOrder] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateFields, setUpdateFields] = useState(false);
  const [openOrders, setOpenOrders] = useState<string>("open");
  const [selectedIndexes, setSelectedIndexes] = useState<boolean[]>([]);
  const [cols, setCols] = useState<Array<IField>>([]);
  const [colsOrdersClosed, setColsOrdersClosed] = useState<Array<IField>>([]);
  const [colsOrdersPending, setColsOrdersPending] = useState<Array<IField>>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [currentPagePending, setCurrentPagePending] = useState(1);
  const [actionsMenus, setActionsMenus] = useState<IToggleMenuOption[]>([]);
  const [coin, setCoin] = useState<any>([]);
  const [coinClosed, setCoinClosed] = useState<any>([]);
  const [coinPending, setCoinPending] = useState<any>([]);
  const [broker, setBroker] = useState<any>([]);
  const [brokerClosed, setBrokerClosed] = useState<any>([]);
  const [brokerPending, setBrokerPending] = useState<any>([]);
  const [entry, setEntry] = useState<any>([]);
  const [quantityPerPage, setQuantityPerPage] = useState<string | null>(null);
  const [growing, setGrowing] = useState({
    item: "",
    asc: "",
  });
  const [filterOrders, setFilterOrders] = useState({
    corretora: "Binance",
    moeda: "todosPares",
    observacao: "tipoEntrada",
    emissaoInicial: "today",
    emissaoFinal: "today",
    alvo: 0,
  });
  const [filterOrdersClosed, setFilterOrdersClosed] = useState({
    corretora: "Binance",
    moeda: "todosPares",
    observacao: "tipoEntrada",
    emissaoInicial: "today",
    emissaoFinal: "today",
    alvo: 0,
  });
  const [filterOrdersPending, setFilterOrdersPending] = useState({
    corretora: "Binance",
    moeda: "todosPares",
    observacao: "tipoEntrada",
    emissaoInicial: "today",
    emissaoFinal: "today",
    alvo: 0,
  });

  useEffect(() => {
    getCurrentBalance();
    getTableFilds();
    getTableFildsClosed();
    getTableFildsPending();
    getTypeEntry();
    getCoins();
    getCoinsCloseds();
    getCoinsPendings();
  }, []);

  useEffect(() => {
    if (updateFields) {
      initialValues("all");
    }
    if (openOrders) {
      initialValues(openOrders);
    }
  }, [updateFields, openOrders]);

  useEffect(() => {
    if (openOrders === "open") {
      if (
        filterOrders.corretora !== "todasCorretoras" ||
        filterOrders.moeda !== "todosPares" ||
        filterOrders.observacao !== "tipoEntrada" ||
        filterOrders.alvo > 0 ||
        (filterOrders.emissaoInicial !== "today" &&
          filterOrders.emissaoFinal !== "today")
      ) {
        filterOrder(filterOrders);
      } else {
        filterOrder();
      }
    } else if (openOrders === "closed") {
      if (
        filterOrdersClosed.corretora !== "todasCorretoras" ||
        filterOrdersClosed.moeda !== "todosPares" ||
        filterOrdersClosed.observacao !== "tipoEntrada" ||
        filterOrdersClosed.alvo > 0 ||
        (filterOrdersClosed.emissaoInicial !== "today" &&
          filterOrdersClosed.emissaoFinal !== "today")
      ) {
        filterOrder(filterOrdersClosed);
      } else {
        filterOrder();
      }
    } else {
      if (
        filterOrdersPending.corretora !== "todasCorretoras" ||
        filterOrdersPending.moeda !== "todosPares" ||
        filterOrdersPending.observacao !== "tipoEntrada" ||
        filterOrdersPending.alvo > 0 ||
        (filterOrdersPending.emissaoInicial !== "today" &&
          filterOrdersPending.emissaoFinal !== "today")
      ) {
        filterOrder(filterOrdersPending);
      } else {
        filterOrder();
      }
    }
  }, [
    currentPage,
    currentPageClosed,
    currentPagePending,
    growing,
    quantityPerPage,
    filterOrders,
    filterOrdersClosed,
    filterOrdersPending,
  ]);

  useEffect(() => {
    return () => closeModal();
  }, []);

  const getCoins = async () => {
    try {
      let idUser = user?.id;
      if (idUser) {
        const result = await getCoin(idUser);
        if (result) {
          setCoin(result);
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const getCoinsCloseds = async () => {
    try {
      let idUser = user?.id;
      if (idUser) {
        const result = await getCoinClosed(idUser);
        if (result) {
          setCoinClosed(result);
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const getCoinsPendings = async () => {
    try {
      let idUser = user?.id;
      if (idUser) {
        const result = await getCoinPending(idUser);
        if (result) {
          setCoinPending(result);
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const getTypeEntry = async () => {
    try {
      const result = await provider.get();
      if (result) {
        const _result = result.map(
          (item: any) => item.charAt(0).toUpperCase() + item.slice(1)
        );

        setEntry(_result);
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const handleFilter = (key: string, value: string) => {
    if (openOrders === "open") {
      if (key === "corretora") {
        setFilterOrders({
          ...filterOrders,
          [key]:
            value === "Todas as Corretoras" || value === ""
              ? "todasCorretoras"
              : value,
        });
      } else if (key === "moeda") {
        setFilterOrders({
          ...filterOrders,
          [key]:
            value === "Todas as Moedas" || value === "" ? "todosPares" : value,
        });
      } else if (key === "observacao") {
        setFilterOrders({
          ...filterOrders,
          [key]:
            value === "Tipo de Entrada" || value === "" ? "tipoEntrada" : value,
        });
      } else if (key === "alvo") {
        setFilterOrders({ ...filterOrders, [key]: +value });
      } else {
        if (value) {
          setFilterOrders({
            ...filterOrders,
            [key]:
              key === "emissaoInicial"
                ? (value += "T00:00:00.000Z")
                : (value += "T23:59:59.000Z"),
          });
        } else {
          setFilterOrders({
            ...filterOrders,
            [key]: "today",
          });
        }
      }
    } else if (openOrders === "closed") {
      if (key === "corretora") {
        setFilterOrdersClosed({
          ...filterOrdersClosed,
          [key]:
            value === "Todas as Corretoras" || value === ""
              ? "todasCorretoras"
              : value,
        });
      } else if (key === "moeda") {
        setFilterOrdersClosed({
          ...filterOrdersClosed,
          [key]:
            value === "Todas as Moedas" || value === "" ? "todosPares" : value,
        });
      } else if (key === "observacao") {
        setFilterOrdersClosed({
          ...filterOrdersClosed,
          [key]:
            value === "Tipo de entrada" || value === "" ? "tipoEntrada" : value,
        });
      } else if (key === "alvo") {
        setFilterOrdersClosed({ ...filterOrdersClosed, [key]: +value });
      } else {
        if (value) {
          setFilterOrdersClosed({
            ...filterOrders,
            [key]:
              key === "emissaoInicial"
                ? (value += "T00:00:00.000Z")
                : (value += "T23:59:59.000Z"),
          });
        } else {
          setFilterOrdersClosed({
            ...filterOrders,
            [key]: "today",
          });
        }
      }
    } else {
      if (key === "corretora") {
        setFilterOrdersPending({
          ...filterOrdersPending,
          [key]:
            value === "Todas as Corretoras" || value === ""
              ? "todasCorretoras"
              : value,
        });
      } else if (key === "moeda") {
        setFilterOrdersPending({
          ...filterOrdersPending,
          [key]:
            value === "Todas as Moedas" || value === "" ? "todosPares" : value,
        });
      } else if (key === "observacao") {
        setFilterOrdersPending({
          ...filterOrdersPending,
          [key]:
            value === "Tipo de entrada" || value === "" ? "tipoEntrada" : value,
        });
      } else {
        if (value) {
          setFilterOrdersPending({
            ...filterOrders,
            [key]:
              key === "emissaoInicial"
                ? (value += "T00:00:00.000Z")
                : (value += "T23:59:59.000Z"),
          });
        } else {
          setFilterOrdersPending({
            ...filterOrders,
            [key]: "today",
          });
        }
      }
    }
  };

  const getCurrentBalance = async () => {
    setLoading(true);
    try {
      const result = await getBalance(user?.id);
      if (result) {
        const filterBalance = result.balances.filter((item: any) => {
          if (["USDT", "BRL", "BNB"].includes(item.asset)) {
            return {
              asset: item.asset,
              free: item.free,
            };
          }
        });
        setBalance(filterBalance);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Erro ao consultar saldo");
      console.error("Erro: ", error);
      setLoading(false);
    }
  };

  const initialValues = (value: string) => {
    if (value === "closed") {
      initialValuesOrder();
      initialValuesOrderPending();
    } else if (value === "open") {
      initialValuesOrderClosed();
      initialValuesOrderPending();
    } else if (value === "pending") {
      initialValuesOrder();
      initialValuesOrderClosed();
    } else {
      initialValuesOrder();
      initialValuesOrderClosed();
      initialValuesOrderPending();
    }
  };

  const initialValuesOrder = () => {
    setFilterOrders({
      ...filterOrders,
      corretora: "Binance",
      moeda: "todosPares",
      observacao: "tipoEntrada",
      emissaoInicial: "today",
      emissaoFinal: "today",
      alvo: 0,
    });
  };

  const initialValuesOrderClosed = () => {
    setFilterOrdersClosed({
      ...filterOrdersClosed,
      corretora: "Binance",
      moeda: "todosPares",
      observacao: "tipoEntrada",
      emissaoInicial: "today",
      emissaoFinal: "today",
      alvo: 0,
    });
  };

  const initialValuesOrderPending = () => {
    setFilterOrdersPending({
      ...filterOrdersPending,
      corretora: "Binance",
      moeda: "todosPares",
      observacao: "tipoEntrada",
      emissaoInicial: "today",
      emissaoFinal: "today",
      alvo: 0,
    });
  };

  const getTableFilds = async (filter?: any) => {
    // Função responsável por dar get em todas as colunas da tabelas e as ordens abertas
    setUpdate(true);
    try {
      // setLoadingSellOrder(true);
      const id = user?.id;
      const result = await fields.get({ id, filters });
      if (result) {
        let fieldsOrder = [
          {
            campo: "precoAtual",
            coin: "USD",
            decimalPrecision: 6,
            editavel: false,
            nome: "Preço Atual",
            mascara: "dinheiro",
            order: 26,
            required: true,
            tipo: "texto",
          },
          {
            campo: "profitLoss",
            editavel: false,
            nome: "P/L#",
            order: 27,
            required: true,
            tipo: "texto",
          },
          {
            campo: "profitLossPercent",
            editavel: false,
            nome: "P/L%",
            order: 28,
            required: true,
            tipo: "texto",
          },
        ];
        let fieldsOrderClosed = [
          {
            campo: "lucroPercent",
            editavel: false,
            nome: "Lucro %",
            order: 35,
            required: true,
            tipo: "texto",
          },
        ];

        const openOrders = result.filter(
          (item: any) =>
            item.campo !== "aprovacao" &&
            item.campo !== "comissao" &&
            item.campo !== "lucroLiquido" &&
            item.campo !== "diasPendente"
        );
        const closedOrders = result.filter(
          (item: any) =>
            item.campo !== "unitario" && item.campo !== "diasPendente"
        );

        const pendingOrders = result.filter(
          (item: any) =>
            item.campo !== "aprovacao" &&
            item.campo !== "unitario" &&
            item.campo !== "lucroLiquido" &&
            item.campo !== "cancelamento" &&
            item.campo !== "observacao"
        );

        const fieldsOpenOrders = [...fieldsOrder, ...openOrders];
        const allFieldsOrdersClosed = [...closedOrders, ...fieldsOrderClosed];

        const openOrders_cols = fieldsOpenOrders.sort(orderCols);
        const closedOrders_cols = allFieldsOrdersClosed.sort(orderCols);
        const pendingOrder_cols = pendingOrders.sort(orderCols);

        setCols(openOrders_cols);
        setColsOrdersClosed(closedOrders_cols);
        setColsOrdersPending(pendingOrder_cols);

        if (filter) {
          if (filter === "update") {
            setUpdateFields(true);
            getCurrentBalance();
          } else {
            const resultOrders = await getOpenOrders(
              currentPage,
              user?.id,
              growing,
              quantityPerPage,
              filter
            );
            if (resultOrders) {
              const newCoin: any = [];
              const newBroker: any = [];

              const filterCoin = resultOrders.docs.map(
                (item: any) => item.moeda
              );
              const _filterCoin = new Set(filterCoin);

              const filterBroker = resultOrders.docs.map(
                (item: any) => item.Pessoa.nome
              );
              const _filterBroker = new Set(filterBroker);

              _filterCoin.forEach((item) => {
                newCoin.push(item);
              });
              _filterBroker.forEach((item) => {
                newBroker.push(item);
              });

              // setCoin(newCoin);
              // setBroker(newBroker);
              setOrders(resultOrders);
              setUpdate(false);
              setUpdateFields(false);
              // setLoadingSellOrder(false);
              // initialValues("all");
            }
          }
        } else {
          const resultOrders = await getOpenOrders(
            currentPage,
            user?.id,
            growing,
            quantityPerPage
          );
          if (resultOrders) {
            const newCoin: any = [];
            const newBroker: any = [];

            const filterCoin = resultOrders.docs.map((item: any) => item.moeda);
            const _filterCoin = new Set(filterCoin);

            const filterBroker = resultOrders.docs.map(
              (item: any) => item.Pessoa.nome
            );
            const _filterBroker = new Set(filterBroker);

            _filterCoin.forEach((item: any) => {
              newCoin.push(item);
            });
            _filterBroker.forEach((item: any) => {
              newBroker.push(item);
            });

            // setCoin(newCoin);
            setBroker(newBroker);
            setOrders(resultOrders);
            setUpdate(false);
            setUpdateFields(false);
            // setLoadingSellOrder(false);
            // initialValues("all");
          }
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
    setUpdate(false);
  };

  const getTableFildsClosed = async (filter?: any) => {
    // Função responsável por dar get nas ordens fechadas
    try {
      setUpdate(true);
      if (filter) {
        const resultOrders = await getClosedOrders(
          currentPageClosed,
          user?.id,
          growing,
          quantityPerPage,
          filter
        );

        if (resultOrders) {
          const newCoin: any = [];
          const newBroker: any = [];

          const filterCoin = resultOrders.docs.map((item: any) => item.moeda);
          const _filterCoin = new Set(filterCoin);

          const filterBroker = resultOrders.docs.map(
            (item: any) => item.Pessoa.nome
          );
          const _filterBroker = new Set(filterBroker);

          _filterCoin.forEach((item) => {
            newCoin.push(item);
          });
          _filterBroker.forEach((item) => {
            newBroker.push(item);
          });

          // setCoinClosed(newCoin);
          setBrokerClosed(newBroker);
          setOrdersClosed(resultOrders);
          setUpdate(false);
        }
      } else {
        const resultOrders = await getClosedOrders(
          currentPageClosed,
          user?.id,
          growing,
          quantityPerPage
        );

        if (resultOrders) {
          const newCoin: any = [];
          const newBroker: any = [];

          const filterCoin = resultOrders.docs.map((item: any) => item.moeda);
          const _filterCoin = new Set(filterCoin);

          const filterBroker = resultOrders.docs.map(
            (item: any) => item.Pessoa.nome
          );
          const _filterBroker = new Set(filterBroker);

          _filterCoin.forEach((item) => {
            newCoin.push(item);
          });
          _filterBroker.forEach((item) => {
            newBroker.push(item);
          });

          // setCoinClosed(newCoin);
          setBrokerClosed(newBroker);
          setOrdersClosed(resultOrders);
          setUpdate(false);
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const getTableFildsPending = async (filter?: any) => {
    // Função responsável por dar get nas ordens pendentes
    try {
      setUpdate(true);
      if (filter) {
        const resultOrders = await getPendingOrders(
          currentPageClosed,
          user?.id,
          filter
        );
        if (resultOrders) {
          const newCoin: any = [];
          const newBroker: any = [];

          const filterCoin = resultOrders.docs.map((item: any) => item.moeda);
          const _filterCoin = new Set(filterCoin);

          const filterBroker = resultOrders.docs.map(
            (item: any) => item.Pessoa.nome
          );
          const _filterBroker = new Set(filterBroker);

          _filterCoin.forEach((item) => {
            newCoin.push(item);
          });
          _filterBroker.forEach((item) => {
            newBroker.push(item);
          });

          setBrokerPending(newBroker);
          // setCoinPending(newCoin);
          setOrdersPending(resultOrders);
          setUpdate(false);
        }
      } else {
        const result = await getPendingOrders(currentPagePending, user?.id);
        if (result) {
          const newCoin: any = [];
          const newBroker: any = [];

          const filterCoin = result.docs.map((item: any) => item.moeda);
          const _filterCoin = new Set(filterCoin);

          const filterBroker = result.docs.map((item: any) => item.Pessoa.nome);
          const _filterBroker = new Set(filterBroker);

          _filterCoin.forEach((item) => {
            newCoin.push(item);
          });
          _filterBroker.forEach((item) => {
            newBroker.push(item);
          });

          setBrokerPending(newBroker);
          // setCoinPending(newCoin);
          setOrdersPending(result);
          setUpdate(false);
        }
      }
    } catch (error) {
      console.error("Erro: ", error);
    }
  };

  const filterOrder = (filter?: any) => {
    // Função responsável por realizar um filtro de acordo com a opção que o usuário escolher
    if (filter) {
      if (
        isAfter(parseISO(filter.emissaoInicial), parseISO(filter.emissaoFinal))
      ) {
        Toast.show(
          "Favor informar uma data válida, a data final não pode ser inferior a data inicial.",
          "error"
        );
      } else {
        if (openOrders === "open") {
          getTableFilds(filter);
        } else if (openOrders === "closed") {
          getTableFildsClosed(filter);
        } else {
          getTableFildsPending(filter);
        }
      }
    } else {
      getTableFilds();
      getTableFildsClosed();
      getTableFildsPending();
    }
  };

  const handleChangePage = (page: number) => {
    if (openOrders === "open") {
      if (page + 1 !== currentPage) {
        setCurrentPage(page + 1);
      }
    } else if (openOrders === "closed") {
      if (page + 1 !== currentPageClosed) {
        setCurrentPageClosed(page + 1);
      }
    } else {
      if (page + 1 !== currentPagePending) {
        setCurrentPagePending(page + 1);
      }
    }
  };
  console.log(currentPageClosed);

  const handleModal = () => {
    openModal({
      type: "confirm",
      // title: "Nova Ordem",
      wide: "340px",
      children: () => (
        <LabelModal
          getTableFilds={getTableFilds}
          getCurrentBalance={getCurrentBalance}
          getTableFildsPending={getTableFildsPending}
        />
      ),
    });
  };

  const dataTable = () => {
    if (openOrders && filteredOrders) {
      return filteredOrders.docs;
    } else if (openOrders && !filteredOrders && orders) {
      return orders.docs;
    } else if (!openOrders && filteredOrdersClosed) {
      return filteredOrdersClosed.docs;
    } else if (!openOrders && !filteredOrdersClosed && ordersClosed) {
      return ordersClosed.docs;
    } else {
      return [];
    }
  };

  const sellOrder = async () => {
    setLoadingSellOrder(true);
    const ids = itensSelected();
    if (ids) {
      try {
        const result = await postSellOrder(ids, user?.id);
        if (result.status === 201) {
          toast.success("Venda realizada com sucesso.");
          await getTableFilds();
          await getTableFildsClosed();
          setLoadingSellOrder(false);
        }
      } catch (error: any) {
        console.error("Erro: ", error);
        Toast.show(error.message, "error");
        setLoadingSellOrder(false);
      }
    }
    setLoadingSellOrder(false);
  };

  const pauseOrder = async () => {
    setLoadingSellOrder(true);
    const ids = itensSelected();
    if (ids) {
      try {
        const response = await postPauseOrder(ids, user?.id);

        if (response.status === 201) {
          toast.success("Ordem pausada.");
          await getTableFilds();
          await getTableFildsClosed();
          setLoadingSellOrder(false);
        }
      } catch (error: any) {
        console.error("Erro: ", error);
        Toast.show(error.message, "error");
        setLoadingSellOrder(false);
      }
    }
  };

  const itensSelected = () => {
    const itens: any = [];

    if (orders) {
      let docs = [...orders?.docs];
      let selection = [...selectedIndexes];

      selectedIndexes.map((item: any, index: any) => {
        if (item == true) {
          itens.push(docs[index].chcriacao);
          selection.splice(index, 1);
        }
      });

      itens.map((item: any) => {
        let itemIndex = docs.findIndex((i: any) => i === item);
        if (itemIndex >= 0) {
          docs.splice(itemIndex, 1);
        }
      });

      // setSelectedIndexes(selection)
    }
    if (itens.length > 0) {
      return itens;
    } else {
      toast.error("Selecione a ordem que deseja vender");
    }
  };

  const handleOrderCols = (value: string) => {
    if (value === "Par" || value === "Quantidade") {
      if (growing.item === value) {
        setGrowing({
          ...growing,
          item: growing.asc == "false" ? "" : value,
          asc: growing.asc == "false" ? "" : "false",
        });
      } else {
        setGrowing({
          ...growing,
          item: value,
          asc: "true",
        });
      }
    }
  };

  const handleQuantityPerPage = (value: string) => {
    setQuantityPerPage(value);
  };

  const formatedDate = (date: string) => {
    const data = date.slice(0, 10);
    return data;
  };

  return (
    <Container>
      <Title>{title}</Title>
      <DivCard className="balance">
        <Row wide={"auto"} aItems={"baseline"}>
          <label htmlFor="">Saldo</label>
          <div className="rowBalanceValue">
            {balance.length > 0
              ? balance.map((item: any, index: any) => (
                  <div key={index} className="balanceValue">
                    <p>
                      ${Number(item.free).toFixed(2)} {item.asset}
                    </p>
                  </div>
                ))
              : null}
          </div>
        </Row>
        <Row wide={"auto"}>
          <span>
            {loading ? (
              <>
                <AiOutlineLoading /> &nbsp;
              </>
            ) : null}
          </span>
          {/* <Button
            wide={"auto"}
            disabled={loading}
            onClick={() => getCurrentBalance()}
          >
            Atualizar
          </Button> */}
        </Row>
      </DivCard>
      <DivCard>
        <RowButtonOrder className="buttonsOrder">
          <button
            className="buttonOrder"
            type="button"
            onClick={() => setOpenOrders("open")}
          >
            <p className={openOrders === "open" ? "primary" : ""}>
              Abertas{orders?.total ? `(${orders.total})` : "(0)"}
            </p>
          </button>
          <button
            className="buttonOrder"
            type="button"
            onClick={() => setOpenOrders("closed")}
          >
            <p className={openOrders === "closed" ? "primary" : ""}>
              Fechadas{ordersClosed?.total ? `(${ordersClosed.total})` : "(0)"}
            </p>
          </button>
          <button
            className="buttonOrder"
            type="button"
            onClick={() => setOpenOrders("pending")}
          >
            <p className={openOrders === "pending" ? "primary" : ""}>
              Pendentes
              {ordersPending?.total ? `(${ordersPending.total})` : "(0)"}
            </p>
          </button>
        </RowButtonOrder>
      </DivCard>

      <DivCard className="filters">
        <Row wide={"auto"} className="filters">
          <p className="primary">Filtros</p>
          {openOrders === "open" ? (
            <form autoComplete="off">
              {/* <div>
                <input
                  list="broker"
                  name="myBroker"
                  id="myBroker"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrders.corretora !== "todasCorretoras"
                      ? filterOrders.corretora
                      : ""
                  }
                  onChange={(ev) => handleFilter("corretora", ev.target.value)}
                  placeholder={filterOrders.corretora.replace(
                    "todasCorretoras",
                    "Todas Corretoras"
                  )}
                />
                <datalist id="broker">
                  {broker ?
                    broker.map((item: string) => (
                      <option value={item}>{item}</option>
                    )) : null}
                </datalist>
              </div> */}
              <div>
                <input
                  list="coinOpen"
                  name="myCoinOpen"
                  id="myCoinOpen"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrders.moeda !== "todosPares"
                      ? filterOrders.moeda
                      : ""
                  }
                  onChange={(ev) => handleFilter("moeda", ev.target.value)}
                  placeholder={filterOrders.moeda.replace(
                    "todosPares",
                    "Todas Moedas"
                  )}
                />
                <datalist id="coinOpen">
                  {coin
                    ? coin.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              <div>
                <input
                  list="entryOpen"
                  name="myEntryOpen"
                  id="myEntryOpen"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrders.observacao !== "tipoEntrada"
                      ? filterOrders.observacao
                      : ""
                  }
                  onChange={(ev) => handleFilter("observacao", ev.target.value)}
                  placeholder={filterOrders.observacao.replace(
                    "tipoEntrada",
                    "Tipo Entrada"
                  )}
                />
                <datalist id="entryOpen">
                  {entry.length > 0
                    ? entry.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              {/* <div>
                <input
                  className="small"
                  type="number"
                  name="alvo"
                  id="alvo"
                  value={filterOrders.alvo > 0 ? filterOrders.alvo : ""}
                  onChange={(ev) => handleFilter("alvo", ev.target.value)}
                  placeholder="% alvo"
                />
              </div> */}
              <div>
                <label htmlFor="emissaoInicial">
                  De: &nbsp;
                  <input
                    type="date"
                    name="emissaoInicial"
                    id="emissaoInicial"
                    value={
                      filterOrders.emissaoInicial !== "today"
                        ? formatedDate(filterOrders.emissaoInicial)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoInicial", ev.target.value)
                    }
                  />
                </label>
              </div>
              <div>
                <label htmlFor="emissaoFinal">
                  Até: &nbsp;
                  <input
                    type="date"
                    name="emissaoFinal"
                    id="emissaoFinal"
                    value={
                      filterOrders.emissaoFinal !== "today"
                        ? formatedDate(filterOrders.emissaoFinal)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoFinal", ev.target.value)
                    }
                  />
                </label>
              </div>
            </form>
          ) : openOrders === "closed" ? (
            <form autoComplete="off" style={{ display: "flex" }}>
              {/* <div>
                <input
                  list="brokerClosed"
                  name="myBrockerClosed"
                  id="myBrockerClosed"
                  type="search"
                  autoComplete="off"
                  value={
                    filterOrdersClosed.corretora !== "todasCorretoras"
                      ? filterOrdersClosed.corretora
                      : ""
                  }
                  onChange={(ev) => handleFilter("corretora", ev.target.value)}
                  placeholder={filterOrdersClosed.corretora.replace(
                    "todasCorretoras",
                    "Todas Corretoras"
                  )}
                />
                <datalist id="brokerClosed">
                  {brokerClosed ?
                    brokerClosed.map((item: string) => (
                      <option value={item}>{item}</option>
                    )) : null}
                </datalist>
              </div> */}
              <div>
                <input
                  list="coinClosed"
                  name="myCoinClosed"
                  id="myCoinClosed"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrdersClosed.moeda !== "todosPares"
                      ? filterOrdersClosed.moeda
                      : ""
                  }
                  onChange={(ev) => handleFilter("moeda", ev.target.value)}
                  placeholder={filterOrdersClosed.moeda.replace(
                    "todosPares",
                    "Todas Moedas"
                  )}
                />
                <datalist id="coinClosed">
                  {coinClosed
                    ? coinClosed.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              <div>
                <input
                  list="entryClosed"
                  name="myEntryClosed"
                  id="myEntryClosed"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrdersClosed.observacao !== "tipoEntrada"
                      ? filterOrdersClosed.observacao
                      : ""
                  }
                  onChange={(ev) => handleFilter("observacao", ev.target.value)}
                  placeholder={filterOrdersClosed.observacao.replace(
                    "tipoEntrada",
                    "Tipo Entrada"
                  )}
                />
                <datalist id="entryClosed">
                  {entry.length > 0
                    ? entry.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              {/* <div>
                <input
                  className="small"
                  type="number"
                  name="alvo"
                  id="alvo"
                  value={
                    filterOrdersClosed.alvo > 0 ? filterOrdersClosed.alvo : ""
                  }
                  onChange={(ev) => handleFilter("alvo", ev.target.value)}
                  placeholder="% alvo"
                />
              </div> */}
              <div>
                <label htmlFor="fromClosed">
                  De: &nbsp;
                  <input
                    type="date"
                    name="fromClosed"
                    id="fromClosed"
                    value={
                      filterOrdersClosed.emissaoInicial !== "today"
                        ? formatedDate(filterOrdersClosed.emissaoInicial)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoInicial", ev.target.value)
                    }
                  />
                </label>
              </div>
              <div>
                <label htmlFor="toClosed">
                  Até: &nbsp;
                  <input
                    type="date"
                    name="toClosed"
                    id="toClosed"
                    value={
                      filterOrdersClosed.emissaoFinal !== "today"
                        ? formatedDate(filterOrdersClosed.emissaoFinal)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoFinal", ev.target.value)
                    }
                  />
                </label>
              </div>
            </form>
          ) : (
            <form autoComplete="off" style={{ display: "flex" }}>
              {/* <div>
                <input
                  list="brokerPending"
                  name="myBrockerPending"
                  id="myBrockerPending"
                  type="search"
                  autoComplete="off"
                  value={
                    filterOrdersPending.corretora !== "todasCorretoras"
                      ? filterOrdersPending.corretora
                      : ""
                  }
                  onChange={(ev) => handleFilter("corretora", ev.target.value)}
                  placeholder={filterOrdersPending.corretora.replace(
                    "todasCorretoras",
                    "Todas Corretoras"
                  )}
                />
                <datalist id="brokerPending">
                  {brokerPending ?
                    brokerPending.map((item: string) => (
                      <option value={item}>{item}</option>
                    )) : null}
                </datalist>
              </div> */}
              <div>
                <input
                  list="coinPending"
                  name="myCoinPending"
                  id="myCoinPending"
                  type="search"
                  autoComplete="crhome-off"
                  value={
                    filterOrdersPending.moeda !== "todosPares"
                      ? filterOrdersPending.moeda
                      : ""
                  }
                  onChange={(ev) => handleFilter("moeda", ev.target.value)}
                  placeholder={filterOrdersPending.moeda.replace(
                    "todosPares",
                    "Todas Moedas"
                  )}
                />
                <datalist id="coinPending">
                  {coinPending
                    ? coinPending.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              <div>
                <input
                  list="entryPending"
                  name="myEntryPending"
                  id="myEntryPending"
                  type="search"
                  autoComplete="chrome-off"
                  value={
                    filterOrdersPending.observacao !== "tipoEntrada"
                      ? filterOrdersPending.observacao
                      : ""
                  }
                  onChange={(ev) => handleFilter("observacao", ev.target.value)}
                  placeholder={filterOrdersPending.observacao.replace(
                    "tipoEntrada",
                    "Tipo Entrada"
                  )}
                />
                <datalist id="entryPending">
                  {entry.length > 0
                    ? entry.map((item: string) => (
                        <option value={item}>{item}</option>
                      ))
                    : null}
                </datalist>
              </div>
              {/* <div>
                <input
                  className="small"
                  type="number"
                  name="alvo"
                  id="alvo"
                  value={
                    filterOrdersPending.alvo > 0 ? filterOrdersPending.alvo : ""
                  }
                  onChange={(ev) => handleFilter("alvo", ev.target.value)}
                  placeholder="% alvo"
                />
              </div> */}
              <div>
                <label htmlFor="fromClosed">
                  De: &nbsp;
                  <input
                    type="date"
                    name="fromClosed"
                    id="fromClosed"
                    value={
                      filterOrdersPending.emissaoInicial !== "today"
                        ? formatedDate(filterOrdersPending.emissaoInicial)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoInicial", ev.target.value)
                    }
                  />
                </label>
              </div>
              <div>
                <label htmlFor="toClosed">
                  Até: &nbsp;
                  <input
                    type="date"
                    name="toClosed"
                    id="toClosed"
                    value={
                      filterOrdersPending.emissaoFinal !== "today"
                        ? formatedDate(filterOrdersPending.emissaoFinal)
                        : ""
                    }
                    autoComplete="chrome-off"
                    onChange={(ev) =>
                      handleFilter("emissaoFinal", ev.target.value)
                    }
                  />
                </label>
              </div>
            </form>
          )}
        </Row>
        {openOrders === "open" ? (
          <Row wide={"auto"} className="loading">
            <span>
              {loadingSellOrder ? (
                <>
                  <AiOutlineLoading /> &nbsp;
                </>
              ) : update ? (
                <>
                  <AiOutlineLoading /> &nbsp;
                </>
              ) : (
                <>&nbsp;</>
              )}
            </span>
            <div className="buttonsAction">
              <Button
                className="small"
                disabled={update}
                onClick={() => getTableFilds("update")}
              >
                Atualizar
              </Button>
              {user?.inativo === false ? (
                <Button className="small" onClick={() => handleModal()}>
                  Nova Ordem
                </Button>
              ) : null}
              <Button
                className="small"
                disabled={loadingSellOrder}
                onClick={() => sellOrder()}
              >
                Vender
              </Button>
              <Button className="small" onClick={() => pauseOrder()}>
                Pausar
              </Button>
            </div>
          </Row>
        ) : (
          <Row wide={"auto"} className="loading">
            <span>
              {loadingSellOrder ? (
                <>
                  <AiOutlineLoading /> &nbsp;
                </>
              ) : update ? (
                <>
                  <AiOutlineLoading /> &nbsp;
                </>
              ) : (
                <>&nbsp;</>
              )}
            </span>
          </Row>
        )}
      </DivCard>

      <Content>
        <ListTable
          multipleSelect={openOrders === "open" ? multipleSelect : false}
          changeSelectedIndexes={setSelectedIndexes}
          fields={
            openOrders === "open"
              ? cols
              : openOrders === "closed"
              ? colsOrdersClosed
              : colsOrdersPending
          }
          data={
            openOrders === "open" && orders
              ? orders.docs
              : openOrders === "closed" && ordersClosed
              ? ordersClosed.docs
              : openOrders === "pending" && ordersPending
              ? ordersPending.docs
              : []
          }
          handleOrderCols={handleOrderCols}
          growing={growing}
          onChangePage={handleChangePage}
          currentPage={openOrders ? currentPage : currentPageClosed}
          totalPages={
            openOrders === "open" && orders
              ? orders.totalPages
              : openOrders === "closed" && ordersClosed
              ? ordersClosed.totalPages
              : openOrders === "pending" && ordersPending
              ? ordersPending.totalPages
              : 1
          }
          count={
            openOrders === "open" && orders
              ? orders.total
              : openOrders === "closed" && ordersClosed
              ? ordersClosed.total
              : openOrders === "pending" && ordersPending
              ? ordersPending.total
              : 0
          }
          rowMenuOptions={actionsMenus}
          withFooter={false}
        />
      </Content>
      <Footer>
        <SelectedContainer>
          <p>Linhas por página: &nbsp;</p>
          <select
            name="quantityPerPage"
            id="quantityPerPage"
            onChange={({ target }) => handleQuantityPerPage(target.value)}
          >
            <option value="5">5</option>
            <option value="10" selected>
              10
            </option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </SelectedContainer>
        <PaginateContainer>
          <ReactPaginate
            breakLabel="..."
            nextLabel=" >"
            onPageChange={({ selected }) => handleChangePage(selected)}
            pageRangeDisplayed={5}
            pageCount={
              openOrders === "open" && orders
                ? orders.totalPages
                : openOrders === "closed" && ordersClosed
                ? ordersClosed.totalPages
                : openOrders === "pending" && ordersPending
                ? ordersPending.totalPages
                : 1
            }
            previousLabel="< "
            renderOnZeroPageCount={undefined}
            activeClassName="active-page-item"
          />
        </PaginateContainer>
      </Footer>
    </Container>
  );
};

export default Order;
